export default "__VITE_ASSET__BleClF1n__"